var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", [_vm._v(_vm._s(_vm.stempelCounter) + " von 10 Stempel")]),
    _vm.stempelCounter >= 10
      ? _c("div", { staticClass: "mt-3 mb-3 blink_me" }, [
          _vm._v(
            "Du hast es geschafft! Deine Stempelkarte ist voll und jetzt kannst du dein Guthaben von "
          ),
          _c("b", [
            _vm._v(_vm._s(_vm.$store.getters.stempelRabattAmount) + " Euro"),
          ]),
          _vm._v(
            " bei der nächsten Bestellung einlösten oder bei einer zukünftigen Bestellung deiner Wahl. "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }